import * as React from "react";
const SvgFiRrMapMarkerPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.175 22.448a5.43 5.43 0 0 0 7.574.019l3.981-3.68c4.314-4.256 4.36-11.203.104-15.516S8.631-1.09 4.318 3.167l-.104.104C-.071 7.556-.07 14.503 4.215 18.788q.014.012.027.026zM5.625 4.68A8.977 8.977 0 1 1 18.347 17.35l-3.974 3.672a3.506 3.506 0 0 1-4.825-.018l-3.925-3.626a8.977 8.977 0 0 1 0-12.696m1.36 6.348c0-.551.446-.998.997-.998h2.993V7.04a.997.997 0 0 1 1.995 0v2.992h2.992a.997.997 0 1 1 0 1.995H12.97v2.993a.997.997 0 1 1-1.995 0v-2.993H7.982a.997.997 0 0 1-.997-.997"
    />
  </svg>
);
export default SvgFiRrMapMarkerPlus;
